import { ConfirmationService, MessageService } from 'primeng/api';
import { TraitementService } from './../../services/traitement-service/traitement.service';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table, TableModule } from 'primeng/table';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gestion-traitement',
  imports: [BreadcrumbModule,
    TableModule,
    FormsModule,
    ButtonModule,
    ToastModule,
    ToolbarModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    TagModule,
    InputIconModule,
    IconFieldModule,
    ConfirmDialogModule, DropdownModule, CommonModule],
  templateUrl: './gestion-traitement.component.html',
  styleUrl: './gestion-traitement.component.scss',
   providers: [ConfirmationService, MessageService,]
})
export class GestionTraitementComponent {
 breadcrumbTraitement = { icon: 'pi pi-home', routerLink: '/rechercher-do' };
  breadcrumbItems = [{ label: 'Gestion Traitement' }];
  DO: any;
  nomDo!: string;
  traitements: any;
  rowsPerPageOptions: number[] = [10]; // Valeur par défaut
  totalRecords: number = 10;
  loading: boolean = true;
  selectedTraitements!: any;
  DetailsDialog: boolean = false;
  selectedTraitementItem: any;
  Traitement: any;

  @ViewChild('filter') filter!: ElementRef;
  @ViewChild('dt1', { static: false }) dt1!: Table;

  constructor(
    private traitementService: TraitementService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,

  ) { }

  ngOnInit() {
    let selectedDoString = sessionStorage.getItem('selectedDo');
    if (selectedDoString) {
      let selectedDo = JSON.parse(selectedDoString);
      this.DO = selectedDo.code_interne;
      this.nomDo = selectedDo.Nom;


      this.loadData();


    } else {
      this.router.navigate(['/rechercher-do']);
    }
  }

  loadData() {
    this.traitementService.getTraitementsByDo(this.DO).subscribe({
      next: (data: any) => {
        this.traitements = data;
        console.log(this.traitements)
        this.totalRecords = data.length;
        this.updateRowsPerPageOptions();
        this.loading = false;
      }
    });
  }
  updateRowsPerPageOptions() {
    const baseOptions = [10, 20, 30, 40, 50];

    // Limitez les options supplémentaires à des valeurs raisonnables
    const maxReasonableOption = 100; // Définissez une limite supérieure raisonnable

    if (this.totalRecords > 50) {
      const additionalOptions = [];
      // Ajoutez des options jusqu'à la limite raisonnable ou au totalRecords (le plus petit des deux)
      const upperLimit = Math.min(this.totalRecords, maxReasonableOption);

      for (let i = 100; i <= upperLimit; i += 100) {
        additionalOptions.push(i);
      }

      this.rowsPerPageOptions = [...baseOptions, ...additionalOptions];
    } else {
      this.rowsPerPageOptions = baseOptions;
    }

    // Ajoutez le totalRecords seulement s'il est raisonnable et différent des options existantes
    if (this.totalRecords <= maxReasonableOption &&
      !this.rowsPerPageOptions.includes(this.totalRecords)) {
      this.rowsPerPageOptions.push(this.totalRecords);
    }
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  clear(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }


  calculateCustomerTotal(name: string) {
    let total = 0;

    if (this.traitements) {
      for (let Traitement of this.traitements) {
        if (Traitement.service === name) {
          total++;
        }
      }
    }

    return total;
  }

  hideDialog() {
    this.DetailsDialog = false;
  }

  openDetailsTraitement(Traitement: any) {
    this.selectedTraitementItem = Traitement;
    this.DetailsDialog = true;
  }

 ExporterTraitementsCSV() {
  this.traitementService.exportTraitementsByDo(this.DO).subscribe({
    next: (blob: Blob) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result as string;
        const bom = '\uFEFF'; // BOM UTF-8
        const blobWithBom = new Blob([bom + text], { type: 'text/csv;charset=utf-8;' });

        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blobWithBom);
        a.href = objectUrl;
        a.download = `${this.DO}_Export_Traitements.csv`;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Fichier téléchargé' });
      };
      reader.readAsText(blob); // ✅ plus d’erreur ici
    },
    error: (err) => {
      console.error('Erreur lors du téléchargement :', err);
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'L\'export a échoué' });
    },
  });
}

}
